<template>
	<v-container align-center>
		<v-layout justify-center>
			<v-flex xs12 sm12 md8>
				<v-layout justify-center row wrap>
					<v-flex pa-1 xs12 sm6>
						<v-autocomplete
							v-model="yearSelected"
							label="Select Year"
							:items="filterYears"
							:autcomplete="false"
							clearable
							class="text-field-wrapper pt-4"
						></v-autocomplete>
					</v-flex>
					<v-flex pa-1 xs12 sm6>
						<v-autocomplete
							label="Select Month tracking"
							v-model="monthSelected"
							:items="filterMonths"
							:autcomplete="false"
							clearable
							:disabled="!yearSelected"
							class="text-field-wrapper pt-4"
						></v-autocomplete>
					</v-flex>
				</v-layout>
				<v-layout class="d-flex flex-column">
					<v-btn
						tile
						class="btn white--text"
						:disabled="
							!(yearSelected && monthSelected) ||
								invoiceBtn.fantasyDisable
						"
						@click="toggleInvoiceModal(true, 'fantasy')"
						:loading="isDownloadingSignedInvoice"
						color="#DAA520"
					>
						{{ invoiceBtn.fantasyText }}
					</v-btn>
					<div
						class="my-1 mx-2 red--text"
						v-if="invoiceRejectionReason.fantasy"
					>
						Previous Fantasy Invoice was rejected - Reason:
						<b>{{ invoiceRejectionReason.fantasy }}</b>
					</div>
					<v-btn
						tile
						class="btn white--text"
						:disabled="
							!(yearSelected && monthSelected) ||
								invoiceBtn.rummyDisable
						"
						@click="toggleInvoiceModal(true, 'rummy')"
						:loading="isDownloadingSignedInvoiceRummy"
						color="#DAA520"
					>
						{{ invoiceBtn.rummyText }}
					</v-btn>
					<div
						class="my-1 mx-2 red--text"
						v-if="invoiceRejectionReason.rummy"
					>
						Previous Rummy Invoice was rejected - Reason:
						<b>{{ invoiceRejectionReason.rummy }}</b>
					</div>
					<v-btn
						:v-if="isJeet11Distributor"
						tile
						class="btn white--text"
						:disabled="
							!(yearSelected && monthSelected) ||
								yearSelected != 2022
						"
						@click="viewSupportInvoice(true)"
						color="#DAA520"
						:loading="isLoadingSupportInvoice"
					>
						View/Download Support Invoice
					</v-btn>
					<v-btn
						:v-if="isJeet11Distributor"
						tile
						class="btn white--text"
						:disabled="!(yearSelected && monthSelected)"
						@click="downloadInvoice('fantasy')"
						:loading="isDownloadingInvoice"
						:color="THEME_INPUT_COLOUR"
					>
						Download Invoice
					</v-btn>
					<v-btn
						tile
						class="btn white--text"
						:disabled="!(yearSelected && monthSelected)"
						@click="downloadCreditNote('fantasy')"
						:loading="isDownloadingCreditNote"
						:color="THEME_INPUT_COLOUR"
					>
						Download Credit Note
					</v-btn>
					<v-btn
						tile
						class="btn white--text"
						:disabled="!(yearSelected && monthSelected)"
						@click="downloadGSTInvoice('fantasy')"
						:loading="isDownloadingGSTInvoice"
						:color="THEME_INPUT_COLOUR"
					>
						Download GST Invoice
					</v-btn>
					<v-btn
						tile
						class="btn white--text"
						:disabled="!(yearSelected && monthSelected)"
						@click="downloadInvoice('fantasy', true)"
						:loading="isDownloadingLedgerInvoiceFantasy"
						:color="THEME_INPUT_COLOUR"
					>
						Statement of Accounts - Fantasy
					</v-btn>
				</v-layout>
				<v-layout class="d-flex flex-column">
					<v-btn
						tile
						class="btn white--text"
						:disabled="!(yearSelected && monthSelected)"
						@click="downloadInvoice('rummy')"
						:loading="isDownloadingRummyInvoice"
						:color="RUMMY_COLOUR"
					>
						Download Rummy Invoice
					</v-btn>
					<v-btn
						tile
						class="btn white--text"
						:disabled="!(yearSelected && monthSelected)"
						@click="downloadCreditNote('rummy')"
						:loading="isDownloadingRummyCreditNote"
						:color="RUMMY_COLOUR"
					>
						Download Rummy Credit Note
					</v-btn>
					<v-btn
						tile
						class="btn white--text"
						:disabled="!(yearSelected && monthSelected)"
						@click="downloadGSTInvoice('rummy')"
						:loading="isDownloadingRummyGSTInvoice"
						:color="RUMMY_COLOUR"
					>
						Download Rummy GST Invoice
					</v-btn>
					<v-btn
						tile
						class="btn white--text"
						:disabled="!(yearSelected && monthSelected)"
						@click="downloadInvoice('rummy', true)"
						:loading="isDownloadingLedgerInvoiceRummy"
						:color="RUMMY_COLOUR"
					>
						Statement of Accounts - RUMMY
					</v-btn>
				</v-layout>
			</v-flex>
			<v-dialog width="600px" persistent v-model="invoiceModal">
				<div class="white pos-rel pa-2 rounded-card">
					<v-btn
						small
						flat
						icon
						@click.stop="toggleInvoiceModal()"
						class="float-right"
					>
						<v-icon size="24">close</v-icon>
					</v-btn>
					<h6 class="headline text-center px-4">
						Download Invoice
					</h6>
					<v-text-field
						v-model="invoiceNo"
						label="Invoice Number*"
						placeholder="Enter the invoice no"
						class="text-field-wrapper mx-4 pt-4"
						filled
					/>
					<div>
						Calculated Taxable Income:
						{{ monthGstValue[invoiceModalType] }}
					</div>
					<v-text-field
						v-model="monthGstValueInput[invoiceModalType]"
						label="Taxable Income (Edit if different)"
						placeholder="Taxable Income"
						class="text-field-wrapper mx-4 pt-4"
						filled
					/>
					<div class="d-flex justify-center px-4 pt-2">
						<v-btn
							:color="THEME_INPUT_COLOUR"
							@click="downloadGSTInvoice(invoiceModalType, true)"
							class="white--text body-2 rounded-card"
							small
							:disabled="!invoiceNo"
							>Submit</v-btn
						>
					</div>
				</div>
			</v-dialog>
			<v-dialog persistent v-model="supportInvoiceModal">
				<pdf
					v-if="supportInvoicePdfPath"
					:src="{
						url: supportInvoicePdfPath
					}"
					:key="supportInvoicePdfPath"
					:resize="true"
				>
					<template slot="loading">
						loading content here...
					</template>
				</pdf>
				<v-layout class="white">
					<v-btn
						@click="downloadPdf"
						color="success"
						v-if="isSupportInvoiceSigned"
						>Download</v-btn
					>
					<v-btn v-else @click="approveDstrInvoice" color="success"
						>Approve and Sign</v-btn
					>
					<v-btn @click="closeSupportInvoiceModal" color="error"
						>Close</v-btn
					>
				</v-layout>
			</v-dialog>
		</v-layout>
	</v-container>
</template>

<script>
import {
	YEARS,
	MONTHS,
	RUMMY_COLOUR,
	THEME_INPUT_COLOUR,
	STATUS
} from "../constants";
import {
	DOWNLOAD_INVOICE,
	DOWNLOAD_CREDIT_NOTE,
	DOWNLOAD_GST_INVOICE,
	SHOW_ALERT,
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	FETCH_DSTR_SUPPORT_INVOICE,
	REVIEW_DSTR_INVOICE
} from "../../store/action-types";
import { __fileDownload } from "../../utils";
import { BASE_URL } from "../../../config";
import ApiService from "@/store/api-service";
import { mapGetters, mapState } from "vuex";
import pdf from "pdfvuer";

export default {
	components: {
		pdf
	},
	data() {
		return {
			yearSelected: 0,
			monthSelected: "",
			downloadDisabledButton: true,
			currentYear: new Date().getFullYear(),
			currentMonth: new Date().getMonth(),
			isDownloadingInvoice: false,
			isDownloadingCreditNote: false,
			isDownloadingGSTInvoice: false,
			isDownloadingRummyInvoice: false,
			isDownloadingRummyCreditNote: false,
			isDownloadingRummyGSTInvoice: false,
			isDownloadingSignedInvoice: false,
			isDownloadingSignedInvoiceRummy: false,
			isDownloadingLedgerInvoiceFantasy: false,
			isDownloadingLedgerInvoiceRummy: false,
			invoiceNo: "",
			invoiceModal: false,
			invoiceStatus: [],
			invoiceBtn: {
				fantasyText: "SIGN GST INVOICE - Fantasy",
				fantasyDisable: false,
				rummyText: "SIGN GST INVOICE - Rummy",
				rummyDisable: false
			},
			RUMMY_COLOUR,
			THEME_INPUT_COLOUR,
			isLoadingSupportInvoice: false,
			isDstrInvoiceReviewing: false,
			supportInvoiceModal: false,
			isSupportInvoiceSigned: false,
			supportInvoicePdfPath: "",
			supportInvoiceId: "",
			invoiceReviewStatus: {
				fantasy: "",
				rummy: ""
			},
			invoiceRejectionReason: {
				fantasy: "",
				rummy: ""
			},
			monthGstValue: {
				fantasy: 0,
				rummy: 0
			},
			monthGstValueInput: {
				fantasy: 0,
				rummy: 0
			},
			isDstrApprovedInvoice: {
				fantasy: false,
				rummy: false
			},
			invoiceModalType: ""
		};
	},
	mounted() {
		this.fetchRetailerDetails();
	},
	methods: {
		isDateValid() {
			const thresholdDate = new Date("31-Jul-2021");
			const thresholdMonth = thresholdDate.getMonth();
			const thresholdYear = thresholdDate.getFullYear();
			const selectedMonth = MONTHS.findIndex(
				month => month === this.monthSelected
			);
			// rejects for september 2021 invoice download
			if (
				(selectedMonth === 8 && this.yearSelected <= thresholdYear) ||
				this.yearSelected < thresholdYear ||
				selectedMonth === -1
			) {
				return false;
			} else if (
				// rejects all dates below August 2021 invoice download
				selectedMonth <= thresholdMonth &&
				this.yearSelected <= thresholdYear
			) {
				return false;
			}
			return true;
		},
		downloadInvoice(invoiceType, isLedgerInvoice) {
			const dateValid = this.isDateValid();
			if (!dateValid) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Contact RBM for Invoice!"
				});
				return;
			}
			if (isLedgerInvoice) {
				invoiceType === "fantasy"
					? (this.isDownloadingLedgerInvoiceFantasy = true)
					: (this.isDownloadingLedgerInvoiceRummy = true);
			} else {
				invoiceType === "fantasy"
					? (this.isDownloadingInvoice = true)
					: (this.isDownloadingRummyInvoice = true);
			}
			this.$store
				.dispatch(DOWNLOAD_INVOICE.dispatch, {
					month: MONTHS.indexOf(this.monthSelected),
					year: this.yearSelected,
					invoiceType,
					isLedgerInvoice
				})
				.catch(() => {})
				.finally(() => {
					if (isLedgerInvoice) {
						invoiceType === "fantasy"
							? (this.isDownloadingLedgerInvoiceFantasy = false)
							: (this.isDownloadingLedgerInvoiceRummy = false);
					} else {
						invoiceType === "fantasy"
							? (this.isDownloadingInvoice = false)
							: (this.isDownloadingRummyInvoice = false);
					}
				});
		},
		downloadCreditNote(invoiceType) {
			const dateValid = this.isDateValid();
			if (!dateValid) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Contact RBM for Credit Note!"
				});
				return;
			}
			invoiceType === "fantasy"
				? (this.isDownloadingCreditNote = true)
				: (this.isDownloadingRummyCreditNote = true);
			this.$store
				.dispatch(DOWNLOAD_CREDIT_NOTE.dispatch, {
					month: MONTHS.indexOf(this.monthSelected),
					year: this.yearSelected,
					invoiceType
				})
				.catch(() => {})
				.finally(() => {
					invoiceType === "fantasy"
						? (this.isDownloadingCreditNote = false)
						: (this.isDownloadingRummyCreditNote = false);
				});
		},
		downloadGSTInvoice(invoiceType, isSigned = false) {
			const dateValid = this.isDateValid();
			if (!dateValid) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Contact RBM for GST Invoice!"
				});
				return;
			}
			if (!isSigned)
				invoiceType === "fantasy"
					? (this.isDownloadingGSTInvoice = true)
					: (this.isDownloadingRummyGSTInvoice = true);
			else {
				invoiceType === "fantasy"
					? (this.isDownloadingSignedInvoice = true)
					: (this.isDownloadingSignedInvoiceRummy = true);
				this.toggleInvoiceModal(null, invoiceType);
			}
			this.$store
				.dispatch(DOWNLOAD_GST_INVOICE.dispatch, {
					month: MONTHS.indexOf(this.monthSelected),
					year: this.yearSelected,
					invoiceType,
					isSigned,
					...(this.invoiceNo ? { invoiceNo: this.invoiceNo } : {}),
					isAmountEdited:
						this.monthGstValueInput[invoiceType] !==
						this.monthGstValue[invoiceType],
					amount: this.monthGstValueInput[invoiceType]
				})
				.then(res => {
					if (typeof res === "string") {
						this.$store.dispatch(SHOW_ALERT.dispatch, {
							text: res
						});
					} else {
						const { errorMsg, isRedirectToProfile } = res;
						this.$store.dispatch(SHOW_ALERT.dispatch, {
							text: errorMsg
						});
						if (isRedirectToProfile) {
							this.$router.replace("/profile");
						}
					}
				})
				.catch(() => {})
				.finally(() => {
					if (isSigned) {
						invoiceType === "fantasy"
							? (this.isDownloadingSignedInvoice = false)
							: (this.isDownloadingSignedInvoiceRummy = false);
						this.fetchRetailerDetails();
						this.getDstrInvoiceStatus();
					} else
						invoiceType === "fantasy"
							? (this.isDownloadingGSTInvoice = false)
							: (this.isDownloadingRummyGSTInvoice = false);
					this.invoiceNo = "";
				});
		},
		updateSignGstBtn(appType) {
			if (!this.monthSelected) return;
			const invoiceStatus = this.invoiceReviewStatus[appType];
			const textKeyToUpdate = `${appType}Text`;
			const disableKeyToUpdate = `${appType}Disable`;
			if (this.isDstrApprovedInvoice[appType]) {
				if (invoiceStatus === STATUS.PENDING) {
					this.invoiceBtn = {
						...this.invoiceBtn,
						[textKeyToUpdate]: `Invoice Approval is pending - ${appType}`,
						[disableKeyToUpdate]: true
					};
				} else if (invoiceStatus === STATUS.APPROVED) {
					this.invoiceBtn = {
						...this.invoiceBtn,
						[textKeyToUpdate]: `Download gst invoice - ${appType}`,
						[disableKeyToUpdate]: false
					};
				} else {
					this.invoiceBtn = {
						...this.invoiceBtn,
						[textKeyToUpdate]: `Sign GST invoice - ${appType}`,
						[disableKeyToUpdate]: false
					};
				}
			} else {
				this.invoiceBtn = {
					...this.invoiceBtn,
					[textKeyToUpdate]: `Sign GST invoice - ${appType}`,
					[disableKeyToUpdate]: false
				};
			}
		},
		toggleInvoiceModal(open = false, invoiceType = null) {
			if (!open) {
				this.invoiceModal = false;
				this.invoiceModalType = "";
				return;
			}
			if (this.dstrSignatureStatus === STATUS.PENDING) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Signature Approval Is Pending!"
				});
				return;
			}
			if (
				this.invoiceReviewStatus[invoiceType] === STATUS.APPROVED &&
				this.isDstrApprovedInvoice[invoiceType]
			) {
				this.downloadGSTInvoice(invoiceType, true);
				return;
			}
			if (this.dstrSignatureStatus === STATUS.REJECTED) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Upload The Signature First!"
				});
				this.$router.replace("/profile");
				return;
			}
			const dateValid = this.isDateValid();
			if (!dateValid) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Contact RBM for GST Invoice!"
				});
				return;
			}
			this.invoiceModal = true;
			this.invoiceModalType = invoiceType;
		},
		fetchRetailerDetails() {
			this.$store.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
				isSchemeRequired: true
			});
		},
		viewSupportInvoice(isSigned) {
			if (this.isLoadingSupportInvoice) {
				return;
			}
			this.isLoadingSupportInvoice = true;
			this.$store
				.dispatch(FETCH_DSTR_SUPPORT_INVOICE.dispatch, {
					month:
						MONTHS.findIndex(
							month => month === this.monthSelected
						) + 1,
					year: this.yearSelected,
					isSigned
				})
				.then(data => {
					const { msg } = data;
					const { invoiceId, fileUrl } = msg;
					if (fileUrl) {
						this.supportInvoiceModal = true;
						this.isSupportInvoiceSigned = isSigned;
						this.supportInvoicePdfPath = fileUrl;
						this.supportInvoiceId = invoiceId;
						this.isLoadingSupportInvoice = false;
					} else {
						this.isLoadingSupportInvoice = false;
						this.viewSupportInvoice(false);
					}
				})
				.catch(() => {
					this.isLoadingSupportInvoice = false;
				});
		},
		approveDstrInvoice() {
			if (this.dstrSignatureStatus === STATUS.PENDING) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Signature Approval Is Pending!"
				});
				return;
			}
			if (this.dstrSignatureStatus === STATUS.REJECTED) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Upload The Signature First!"
				});
				return;
			}
			if (this.isDstrInvoiceReviewing) {
				return;
			}
			this.isDstrInvoiceReviewing = true;
			this.$store
				.dispatch(REVIEW_DSTR_INVOICE.dispatch, {
					status: "accepted",
					invoiceId: this.supportInvoiceId
				})
				.then(() => {
					this.closeSupportInvoiceModal();
				})
				.catch(() => {})
				.finally(() => {
					this.isDstrInvoiceReviewing = false;
				});
		},
		downloadPdf() {
			__fileDownload(this.supportInvoicePdfPath);
		},
		closeSupportInvoiceModal() {
			this.supportInvoicePdfPath = "";
			this.supportInvoiceId = "";
			this.supportInvoiceModal = false;
		},
		async getDstrInvoiceStatus() {
			const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/getDstrInvoiceStatus`;
			const requestPayload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					month: MONTHS.findIndex(
						month => month === this.monthSelected
					),
					year: this.yearSelected
					// type: "fantasy"
				}
			};
			const response = await ApiService.post(endpoint, requestPayload);
			const actualResponse = response.response;
			this.invoiceReviewStatus = {
				fantasy: (actualResponse.fantasy || {}).reviewStatus,
				rummy: (actualResponse.rummy || {}).reviewStatus
			};
			this.invoiceRejectionReason = {
				fantasy: (actualResponse.fantasy || {}).remarks,
				rummy: (actualResponse.rummy || {}).remarks
			};
			this.monthGstValue = {
				fantasy: (actualResponse.fantasy || {}).amount,
				rummy: (actualResponse.rummy || {}).amount
			};
			this.monthGstValueInput = {
				fantasy: (actualResponse.fantasy || {}).amount,
				rummy: (actualResponse.rummy || {}).amount
			};
			this.isDstrApprovedInvoice = {
				fantasy: (actualResponse.fantasy || {}).isDstrApproved,
				rummy: (actualResponse.rummy || {}).isDstrApproved
			};
			this.updateSignGstBtn("fantasy");
			this.updateSignGstBtn("rummy");
		}
	},
	computed: {
		...mapGetters({
			dstrSignatureStatus: "jeet11/dstrSignatureStatus",
			isJeet11Distributor: "auth/isJeet11Distributor"
		}),
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN
		}),
		filterYears() {
			const currentYearIndex = YEARS.indexOf(this.currentYear);
			return YEARS.slice(0, currentYearIndex + 1);
		},
		filterMonths() {
			if (this.yearSelected === 2020) {
				return MONTHS.filter(month => month === "December");
			} else if (this.yearSelected < this.currentYear) {
				return MONTHS;
			}
			return MONTHS.slice(0, this.currentMonth);
		}
	},
	watch: {
		yearSelected(newVal, oldVal) {
			if (oldVal !== newVal) {
				this.monthSelected = "";
			}
		},
		monthSelected(newVal, oldVal) {
			this.invoiceReviewStatus = {
				rummy: "",
				fantasy: ""
			};
			this.invoiceRejectionReason = {
				fantasy: "",
				rummy: ""
			};
			this.invoiceBtn = {
				fantasyText: "SIGN GST INVOICE - Fantasy",
				fantasyDisable: false,
				rummyText: "SIGN GST INVOICE - Rummy",
				rummyDisable: false
			};
			if (oldVal !== newVal && newVal) {
				this.getDstrInvoiceStatus();
			}
		}
	}
};
</script>

<style scoped lang="scss">
.theme--light.v-pagination {
	margin: 4vh 0px;
	li {
		.v-pagination__navigation {
			margin: 0px 4px;
		}
		.v-pagination__item {
			min-width: 26px;
			padding: 3px;
			margin: 2px 3px;
		}
		.v-pagination__more {
			margin: 0;
		}
	}
}
.confirm-dialog {
	display: flex;
	padding: 20px;
	background-color: #fafafa;
}
.rounded-card {
	border-radius: 8px;
}
.float-right {
	position: absolute;
	top: 2px;
	right: 2px;
}
</style>
